import sticky from './_sticky';

export function stickySidebar() {
  const spacingEl = document.querySelector('.sticky-margin');
  let spacing = 0;
  if(spacingEl) spacing = spacingEl.clientHeight

  const sidebar = document.querySelector('.sticky-sidebar');
  if(sidebar) {
    new sticky(sidebar, {
      topSpacing: spacing,
      bottomSpacing: spacing/2,
      containerSelector: '.sticky-container',
      minWidth: 1023
    });
  }
}